import React from 'react';
import { Nav, ButtonBar } from 'C4';

const Header = ({ pathname }) => (
  <div className="header">
    <Nav pathname={pathname} />
    {(pathname ==='/main' || pathname ==='/main/') && pathname.length < 16 && <ButtonBar className="buttonBar" />}
  </div>
);

export default Header;
